export const sizeStyles = {
   ExtraSmall: {
      inputContainerClassName:
         'border-1 rounded-lg text-sm-regular px-12px py-8px',
      inputClassName: 'text-sm-regular'
   },
   Small: {
      inputContainerClassName:
         'border-1 rounded-lg text-md-regular px-14px py-8px',
      inputClassName: 'text-md-regular'
   },
   Medium: {
      inputContainerClassName:
         'border-1 rounded-10px text-md-regular px-14px py-10px',
      inputClassName: 'text-md-regular'
   }
}
